export * from './getStartedAlt';
